import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
/* eslint-disable react/prop-types */
//@ts-check

import React from 'react';
import connect from '../core/EcrionProvider/connect';
import MODAL_COMPONENTS from './variants';
var DEFAULT_ELEVATION = 4;
/**
 * @param {{ modals: [{ type: string; props: Object }] }} props
 */

var ModalRoot = function ModalRoot(_ref) {
  var modals = _ref.modals;
  if (!modals) return null;
  if (!modals.length) return null;
  return React.createElement(React.Fragment, null, modals.map(function (modal, idx) {
    var SpecificModal = MODAL_COMPONENTS[modal.type];
    var hasWindowProps = modal.props && modal.props.windowProps;
    var wProps = modal.props.windowProps;
    var elevation = hasWindowProps && wProps.elevation ? wProps.elevation : DEFAULT_ELEVATION + idx;
    var style = hasWindowProps && wProps.style ? _objectSpread({
      left: 'auto',
      top: 'auto'
    }, wProps.style) : {
      left: 'auto',
      top: 'auto'
    };
    var windowProps = modal.props && modal.props.windowProps ? _objectSpread({}, modal.props.windowProps, {
      elevation: elevation,
      style: style
    }) : {
      elevation: elevation,
      style: style
    };
    return React.createElement(React.Suspense, {
      fallback: null,
      key: modal.type + idx
    }, React.createElement(SpecificModal, Object.assign({}, modal.props, {
      windowProps: windowProps
    })));
  }));
};

export default connect(function (state) {
  return {
    modals: state.modal
  };
})(ModalRoot);